import { signal } from '@preact/signals';
import { Component, createRef } from 'preact';

export async function getPage() {
    const apiUrl = 'api.php?func=get_page&route=' + window.location.pathname;
    const response = await fetch(apiUrl, {method: 'GET', 
        headers: { 'content-type': 'application/json'}});
    const result = await response.json();
    return result.page;
}

export default class ContentPage extends Component {

    pageContent = signal('');

    elRef = createRef();

    private loadContentPage() {
        getPage().then(content => {
            this.pageContent.value = content;
        });

    }

    componentDidMount(): void {

        this.loadContentPage();
        
        const swiperEl = document.querySelector('swiper-container');

        (async () => {
            if (swiperEl) {
                const swiper = await import('swiper/element/bundle');
                swiper.register();
            }
        })();    

    }



    componentWillReceiveProps(nextProps: Readonly<{}>, nextContext: any): void {
        this.loadContentPage();
    }

    componentDidUpdate(previousProps: Readonly<{}>, previousState: Readonly<{}>, snapshot: any): void {
         
        const ref = this.elRef.current as HTMLDivElement;
        if (!ref) {
            return;
        }
        
        ref.querySelectorAll<HTMLTemplateElement>('template.placeholder-script').forEach(el => {
            const script = el.content.querySelector('script');
            
            if (!script) {
                return;
            }

            const orgScript = document.createElement('script');
            for (let i = 0; i < script.attributes.length; i++) {
                const attribute = script.attributes[i];
                orgScript.setAttribute(attribute.name, attribute.value);
                }

            el.replaceWith(orgScript);
        });            
    }

    render() {
        return <div ref={this.elRef} id="content-page" dangerouslySetInnerHTML={{__html: this.pageContent.value}}>
        </div>
    }
}


